import React from 'react';

const CDN = 'https://s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:6df8a3cf/';
export default ({name, className = ''}) => {
    const x1 = `${CDN}${name}.png`;
    const x2 = `${CDN}${name}@2x.png`;
    const x3 = `${CDN}${name}@3x.png`;
    return (
        <img
            className={className}
            src={x1}
            srcSet={
                `${x2} 2x, ${x3} 3x`
            }
        />

    );
}
